import { useEffect, useState } from 'react';

// ─── FrameCounter ─────────────────────────────────────────────────────────────
// Film timecode in the bottom-left corner. Ticks from FRAME 0001 to 2847
// as the user scrolls through all 8 home scenes.
// ─────────────────────────────────────────────────────────────────────────────

export default function FrameCounter({ scrollHostRef }) {
  const [frame, setFrame] = useState(1);

  useEffect(() => {
    const host = scrollHostRef?.current;
    if (!host) return;
    const fn = () => {
      const pct = host.scrollTop / Math.max(host.scrollHeight - host.clientHeight, 1);
      setFrame(Math.round(1 + pct * 2846));
    };
    host.addEventListener('scroll', fn, { passive: true });
    return () => host.removeEventListener('scroll', fn);
  }, [scrollHostRef]);

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: 24,
      zIndex: 9985, pointerEvents: 'none',
    }}>
      <div style={{
        fontFamily: 'var(--font-mono)',
        fontSize: 8,
        color: 'rgba(242,239,232,0.18)',
        letterSpacing: '0.28em',
        marginBottom: 4,
      }}>
        FRAME {String(frame).padStart(4, '0')} / 2847
      </div>
      <div style={{
        width: 72, height: 1,
        background: 'rgba(242,239,232,0.08)',
        position: 'relative',
      }}>
        <div style={{
          position: 'absolute', inset: 0,
          background: 'rgba(242,239,232,0.28)',
          width: `${(frame / 2847) * 100}%`,
          transition: 'width 200ms ease',
        }} />
      </div>
    </div>
  );
}
